import { useEffect, useRef, useState } from "react";
import MapComponent from "../../../components/MapComponent";
import Page from "../../../components/Page/Page";
import { Button, Col, Form, Modal, Select } from "antd";
import nmp_mapboxgl from "@neshan-maps-platform/mapbox-gl";
import { GetAllPaths, GetCustomerLocations } from "../../../API/Map/customerLocation";

import Classes from "./index.module.css";

const ErrorModal = Modal.error;
const InfoModal = Modal.info;

const CustomerLocation = () => {
  const mapRef = useRef(null);
  const [customerLocations, setCustomerLocations] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [opneModal, setModalOpen] = useState(false)
  const [paths, setPaths] = useState([]);


  useEffect(()=>{
    const fetchData=async ()=>{
      const res =await GetAllPaths();
      console.log("res",res)
      if(res.success){
        setPaths(res.data);
      }
    }
    fetchData();
  },[])



  useEffect(() => {
    if(customerLocations.length){
      const bounds = new nmp_mapboxgl.LngLatBounds();
      let coordinate=[];
    customerLocations.map((i) => {

      const marker=new nmp_mapboxgl.Marker({ color: "#30E3CA", scale: 0.5 })
        .setPopup(
          new nmp_mapboxgl.Popup({ offset: 25 }).setText(i.name)
        )
        .setLngLat([i.lng, i.lat])
        .addTo(mapRef.current);
        bounds.extend(marker.getLngLat());
        coordinate=[...coordinate,[i.lng, i.lat]]
    });
    
    mapRef.current.fitBounds(bounds);
    }
  }, [customerLocations]);


  return (
    <>
    <Modal
        open={opneModal}
        footer={[
          <Button
            key="submit"
            onClick={()=>{}}
            loading={buttonLoading}
            type="primary"
          >
            تایید
          </Button>,
          <Button
            key="cancel"
            disabled={buttonLoading}
            onClick={() => {
              setModalOpen(false);
            }}
          >
            لغو
          </Button>,
        ]}
      >
        <Form>
         
            <Col lg={24} md={24} sm={24}>
              <Form.Item label="مسیر" labelAlign="right">
               <Select onChange={(e)=>{}}>
                {paths.map(i=>(<Select.Option value={i.id}>
                    {i.name}
                </Select.Option>))}
               </Select>
              </Form.Item>
            </Col>
            
          
        </Form>
      </Modal>
      <Page>
      <MapComponent
        ref={mapRef}
        buttonLoading={buttonLoading}
        action={() => {
          // setModalOpen(true);
          setButtonLoading(true);
          GetCustomerLocations()
            .then((e) => {
              console.log(e)
              if(e.success){
                setCustomerLocations(e.data);
              }else{
                InfoModal({title:"عدم وجود مختصات",
                  content:"مختصاتی برای مشتریان این مسیر یافت نشد",
                  okText:"تایید"
                })
              }
            }).catch((e)=>{
              ErrorModal({title:"خطا",
                content:"مشکلی هنگام انجام عملیات رخ داد"+e,
                okText:"تایید"
              })
            }).finally(()=>{
              setButtonLoading(false);
            })
        }}
      />
    </Page>
    </>
   
  );
};

export default CustomerLocation;
